const InitPlayground = ({
    gsap,
    playgroundRef,
    projectsRef,
}) => {
    gsap.timeline({
        scrollTrigger: {
            trigger: playgroundRef.current,
            start: "top 0%",
            end: "top -1000%",
            scrub: true,
            toggleActions: "play none none none",
            // markers: true,
            pin: true,
            onEnter: () => { },
            onLeaveBack: () => { }
        },
    })
        .to(projectsRef.current, {
            x: -5000,
            duration: 1, ease: 'none',
        })

    return () => {
        gsap.killTweensOf(playgroundRef);
        gsap.killTweensOf(projectsRef);
    }
}

export default InitPlayground